import type { BreadcrumbItem } from '@/components/NewUI/ModernLayout/Header/Components/StructuredBreadcrumbs';

// The entity crumbs `crumbs.entity` made without a name, and their entity URL parameters.
const unnamedEntities = new WeakMap<BreadcrumbItem, string>();

/** The entity parameter of a `crumbs.entity` crumb the route left for the shell to name. */
export const unnamedEntityOf = (item: BreadcrumbItem): string | undefined =>
  unnamedEntities.get(item);

/**
 * The header crumbs route builders declare (`SingleRootStaticData.breadcrumbs`). An `entity`
 * crumb without a name shows `Entity <id>` until the shell knows the entity's name; `job` labels
 * the job with its id unless the route passes the job's title (`jobName` from the record names).
 */
export const crumbs = {
  entities: (): BreadcrumbItem => ({ name: 'Entities', url: '/admin/entities' }),
  entity: (entityId: string, name?: string): BreadcrumbItem => {
    const url = `/admin/entities/${entityId}`;
    if (name !== undefined) return { name, url };
    const item = { name: `Entity ${entityId}`, url };
    unnamedEntities.set(item, entityId);
    return item;
  },
  jobs: (): BreadcrumbItem => ({ name: 'Jobs', url: '/admin/jobs' }),
  job: (jobId: string, name?: string | null): BreadcrumbItem => ({
    name: name ?? `Job ${jobId}`,
    url: `/admin/jobs/${jobId}`
  }),
  /** The page itself, the last crumb: no link. */
  leaf: (name: string): BreadcrumbItem => ({ name, url: '' })
};
